module.exports = __webpack_public_path__ + "static/ss.f16c8380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/str/ss.png
// module id = 1181
// module chunks = 277036769636407